/* ============================================================
   miori · Käseplatten-Konfigurator
   Vanilla JS, Horizon-kompatibel.
   Submit: posted gleichzeitig an (A) Shopify /contact und
   (B) optional an einen Google-Apps-Script-Endpoint (Sheet).
   ============================================================ */
(function () {
  "use strict";

  function init(root) {
    if (!root || root.dataset.miInit === "1") return;
    root.dataset.miInit = "1";

    // ----- pricing config -----
    const pricePerGuest = parseFloat(root.dataset.pricePerGuest || "14");
    const gramsPerGuest = parseInt(root.dataset.gramsPerGuest || "120", 10);
    const sheetEndpoint = root.dataset.sheetEndpoint || "";

    // ----- elements -----
    const guestsEl = root.querySelector("[data-mi-guests]");
    const guestsMinus = root.querySelector("[data-mi-guests-minus]");
    const guestsPlus = root.querySelector("[data-mi-guests-plus]");
    const guestsSlider = root.querySelector("[data-mi-guests-slider]");
    const previewGrams = root.querySelector("[data-mi-preview-grams]");
    const previewPrice = root.querySelector("[data-mi-preview-price]");
    const form = root.querySelector("[data-mi-form]");
    const successEl = root.querySelector("[data-mi-success]");
    const errorEl = root.querySelector("[data-mi-error]");
    const submitBtn = root.querySelector("[data-mi-submit]");

    // ----- state -----
    let guests = parseInt(guestsEl.textContent, 10) || 6;

    function updatePreview() {
      if (guestsEl) guestsEl.textContent = guests;
      if (guestsSlider) guestsSlider.value = guests;
      if (previewGrams) previewGrams.textContent = (guests * gramsPerGuest) + " g";
      if (previewPrice) previewPrice.textContent = "ab " + (guests * pricePerGuest).toFixed(0) + " €";
    }

    function setGuests(n) {
      guests = Math.max(2, Math.min(40, n));
      updatePreview();
    }

    if (guestsMinus) guestsMinus.addEventListener("click", () => setGuests(guests - 1));
    if (guestsPlus) guestsPlus.addEventListener("click", () => setGuests(guests + 1));
    if (guestsSlider) guestsSlider.addEventListener("input", (e) => setGuests(parseInt(e.target.value, 10)));

    // pill groups (multi-select)
    root.querySelectorAll("[data-mi-pillgroup]").forEach((group) => {
      group.addEventListener("click", (e) => {
        const btn = e.target.closest(".miori-k-pill");
        if (!btn) return;
        e.preventDefault();
        btn.classList.toggle("on");
        // sync hidden input (comma-separated values of .on pills)
        const name = group.dataset.miPillgroup;
        const hidden = group.parentElement.querySelector(`input[name="${name}"]`);
        if (hidden) {
          const vals = Array.from(group.querySelectorAll(".miori-k-pill.on"))
            .map((p) => p.dataset.value).join(", ");
          hidden.value = vals;
        }
      });
    });

    // pill groups (single-select)
    root.querySelectorAll("[data-mi-pillgroup-single]").forEach((group) => {
      group.addEventListener("click", (e) => {
        const btn = e.target.closest(".miori-k-pill");
        if (!btn) return;
        e.preventDefault();
        group.querySelectorAll(".miori-k-pill").forEach((p) => p.classList.remove("on"));
        btn.classList.add("on");
        const name = group.dataset.miPillgroupSingle;
        const hidden = group.parentElement.querySelector(`input[name="${name}"]`);
        if (hidden) hidden.value = btn.dataset.value;
      });
    });

    // form submit
    if (form) {
      form.addEventListener("submit", async (e) => {
        // Shopify form will do the primary POST — we only hijack to ALSO post to sheet
        if (!sheetEndpoint) {
          // Let Shopify handle it natively
          return;
        }
        // Fire-and-forget to sheet, then let Shopify submit normally.
        try {
          const fd = new FormData(form);
          const payload = {};
          fd.forEach((v, k) => { payload[k] = v; });
          payload._timestamp = new Date().toISOString();
          payload._source = "miori-konfigurator";
          // no-cors so Apps Script accepts without preflight
          fetch(sheetEndpoint, {
            method: "POST",
            mode: "no-cors",
            headers: { "Content-Type": "text/plain;charset=utf-8" },
            body: JSON.stringify(payload),
          }).catch(() => { /* silent */ });
        } catch (err) {
          // silent — don't block Shopify submission
        }
        // allow native form submit to continue
      });
    }

    // show success/error banners based on URL params (Shopify redirect pattern)
    try {
      const qs = new URLSearchParams(window.location.search);
      if (qs.get("konfig") === "ok" && successEl) {
        successEl.hidden = false;
        successEl.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      if (qs.get("konfig") === "err" && errorEl) {
        errorEl.hidden = false;
      }
    } catch (e) { /* noop */ }

    updatePreview();
  }

  function bootAll() {
    document.querySelectorAll("[data-mi-config]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootAll);
  } else {
    bootAll();
  }

  // Re-init after Shopify theme editor section re-render
  document.addEventListener("shopify:section:load", bootAll);
})();
